import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestInterceptor } from './auth/request.interceptor';
import { FooterComponent } from './footer/footer.component';
//import { ProfileComponent } from '../layout/profile/profile.component';
import { AuthenticationGuard } from './guards/authentication.guard';
import { CarimboModule } from '../shared/components/carimbo/carimbo.module';
import { HeaderComponent } from './header/header.component';
import { AuthorizationGuard } from './guards/authorization.guard';


@NgModule({
    declarations: [ FooterComponent,
        //ProfileComponent, 
        HeaderComponent],
    exports:[ FooterComponent,
        //ProfileComponent,
         HeaderComponent],
    imports: [CommonModule, RouterModule,CarimboModule],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true
        },AuthenticationGuard,
        AuthenticationGuard.guards,
        AuthorizationGuard
    ]
})
export class CoreModule{

}